import { render } from "./HealthcareHeaderSection.vue?vue&type=template&id=a6ad517e"
import script from "./HealthcareHeaderSection.vue?vue&type=script&lang=js"
export * from "./HealthcareHeaderSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__